import { useCallback, useRef } from 'react';

const NEAR_BOTTOM_THRESHOLD_PX = 200;

export function useChatScroll() {
  /** Sentinel element at the very end of the message list. */
  const containerRef = useRef<HTMLDivElement>(null);
  /** The element that actually scrolls. */
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const isNearBottomRef = useRef(true);

  const scrollToBottom = useCallback(() => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    container.scrollIntoView({behavior: 'smooth', block: 'end'});
  }, []);

  // Tracks whether the reader is at the bottom, so content that grows after
  // render (an image finishing loading) can follow along without yanking
  // someone who scrolled up to read history.
  const handleScroll = useCallback(() => {
    const el = scrollAreaRef.current;
    if (!el) return;
    isNearBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_THRESHOLD_PX;
  }, []);

  const scrollToBottomIfNearBottom = useCallback(() => {
    if (isNearBottomRef.current) scrollToBottom();
  }, [scrollToBottom]);

  return { containerRef, scrollAreaRef, handleScroll, scrollToBottom, scrollToBottomIfNearBottom };
}
